export var MPXAssetType;
(function (MPXAssetType) {
    MPXAssetType["DASH_CBCS_CMAF"] = "DASH_CBCS_CMAF";
    MPXAssetType["DASH_CENC"] = "DASH_CENC";
    MPXAssetType["DASH_CENC_HDR"] = "DASH_CENC_HDR";
    MPXAssetType["DASH_CENC_HDR10"] = "DASH_CENC_HDR10";
    MPXAssetType["DASH_CENC_PRECON"] = "DASH_CENC_PRECON";
    MPXAssetType["DASH_CENC_LGCY"] = "DASH_CENC_LGCY";
    MPXAssetType["DASH_CMAF"] = "DASH_CMAF";
    MPXAssetType["DASH_LIVE"] = "DASH_LIVE";
    MPXAssetType["DASH_TA"] = "DASH_TA";
    MPXAssetType["HLS_AES"] = "HLS AES";
    MPXAssetType["HLS_CBCS_CMAF"] = "HLS_CBCS_CMAF";
    MPXAssetType["HLS_CMAF"] = "HLS_CMAF";
    MPXAssetType["HLS_FPS"] = "HLS_FPS";
    MPXAssetType["HLS_FPS_HDR"] = "HLS_FPS_HDR";
    MPXAssetType["HLS_FPS_PRECON"] = "HLS_FPS_PRECON";
    MPXAssetType["HLS_LIVE"] = "HLS_LIVE";
    MPXAssetType["HLS_TA"] = "HLS_TA";
})(MPXAssetType || (MPXAssetType = {}));
